// extracted by mini-css-extract-plugin
module.exports = {"textModule":"TextModule_textModule__EUGSu"};